import React from "react";
import {Rating} from "@material-ui/lab";

const RatingComponent = () => {
    return (
        <Rating
            defaultValue={4}
            readOnly
        />
    )
}
export default RatingComponent;